import { atom, useAtom } from 'jotai';
import { Cart } from 'containers/Billing/types';
import { Plan } from '@teetsh/app/src/types/plan';

export type BankTransferType = 'transfer' | 'mandate';

interface Payload {
  cart: Cart;
  plans: Plan[];
  type?: BankTransferType;
}

export const payByBankTransferModalPayload = atom<Payload | undefined>(
  undefined,
);

export function usePayByBankTransferModal() {
  const [modalPayload, setModalPayload] = useAtom(
    payByBankTransferModalPayload,
  );
  return {
    isOpen: !!modalPayload,
    open: (v: Payload) => setModalPayload(v),
    closeModal: () => setModalPayload(undefined),
    payload: modalPayload,
    setType: (type: BankTransferType) =>
      setModalPayload(prev => (prev ? { ...prev, type } : prev)),
  };
}
